import { useContext, useEffect, useState } from "react";
import { openDB } from "idb";
import { useNavigate } from "react-router-dom";
import LeftPanel from "../components/LeftPanel";
import Header from "../components/Header";
import SetupTable from "../components/SetupTable";
import SetupModal from "../components/SetupModal";
import DeliverySetupForm from "../components/DeliverySetupForm";
import PickupSetupForm from "../components/PickupSetupForm";
import MealSchedulingForm from "../components/MealSchedulingForm";
import InvoiceSetupForm from "../components/InvoiceSetupForm";
import KotSetupForm from "../components/KotSetupForm";
import styles from "../css/SetupPage.module.css";
import BrandSelectionPopUp from "./BrandSelectionPopUp";
import OutletDetailsSetupForm from "../components/OutletDetailsSetupForm";
import PaymentModesForm from "../components/PaymentModesForm";
import RoleManagmentSetup from "../components/RoleManagmentSetup";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Context from '../context/context'
import PopupRefresh from "../components/PopupRefresh";
import ReferenceSchemeManagePOPUP from "../components/ReferenceScheme";
import KDSSetup from "../components/KDSSetup";
import { ArrowDropDown } from '@mui/icons-material';

const VERSION = 192;
let cursorOverMenu = false;
let mouseOverLinks = false;

export default function SetupPage() {

  const context = useContext(Context);
  const Navigate = useNavigate();
  
  const [pattern, setPattern] = useState("");
  const [modal, setModal] = useState(null);
  const [refreshPage, setRefreshPage] = useState(null);
  const [notification, setNotification] = useState(false);
  const [menuState, setMenuState] = useState(null)
  const [outletState, setOutletState] = useState(null)
  const [orderLinksState, setOrderLinksState] = useState(false);
  const { setUnAuthPopup, upload_backup, showWarning } = context;
  
  const closeModal = () => setModal(null);
  const restrictions = JSON.parse(sessionStorage.getItem("restrictions"))

  const noWarning = () => {
    setUnAuthPopup(true)
    setTimeout(() => {
      setUnAuthPopup(false)
    }, 3000)
  }

  const openInvoiceSetup = async () => {
    const handleInvoiceSelect = invoice_brand => setModal(<InvoiceSetupForm onSave={closeModal} brand_uuid={invoice_brand} />);
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = db.transaction("brand", "readonly").objectStore("brand");
    const brands = await tx.getAll();

    if (brands?.length > 1) setModal({ detached: true, Element: <BrandSelectionPopUp onSelect={handleInvoiceSelect} close={closeModal} /> });
    else handleInvoiceSelect(brands?.[0]?.brand_uuid);
  };

  const tableItems = [
    {
      description: "Delivery Setup",
      action: () => restrictions?.length && +restrictions[0].other_setup_delivery_setup === 0 ? noWarning() : setModal(<DeliverySetupForm onSave={closeModal} />),
    },
    { description: "Fixed Discount & Charges", action: () => restrictions?.length && +restrictions[0].other_setup_fixed_charges_and_discount === 0 ? noWarning() : {} },
    {
      description: "Invoice Setup",
      action: restrictions?.length && +restrictions[0].other_setup_invoice_setup === 0 ? () => noWarning() : openInvoiceSetup,
    },
    {
      description: "KDS Setup (Kitchen Display System)",
      action: () => setModal({
        detached: true,
        Element: <KDSSetup close={closeModal} />
      }),
    },
    {
      description: "KOT Setup",
      action: () => restrictions?.length && +restrictions[0].other_setup_kot_setup === 0 ? noWarning() : setModal(<KotSetupForm onSave={closeModal} />),
    },
    {
      description: "Meal Scheduling",
      action: () => restrictions?.length && +restrictions[0].other_setup_meal_scheduling === 0 ? noWarning() : setModal(<MealSchedulingForm onSave={closeModal} />),
    },
    {
      description: "Outlet Details",
      action: () => restrictions?.length && +restrictions[0].other_setup_outlet_details === 0 ? noWarning() : setModal(<OutletDetailsSetupForm onSave={closeModal} />),
    },
    {
      description: "Payment Modes",
      action: () => restrictions?.length && +restrictions[0].other_setup_payment_mode === 0 ? noWarning() : setModal(<PaymentModesForm onSave={closeModal} />),
    },
    {
      description: "Pickup Setup",
      action: () => restrictions?.length && +restrictions[0].other_setup_pickup_setup === 0 ? noWarning() : setModal(<PickupSetupForm onSave={closeModal} />),
    },
    {
      description: "Role Management",
      action: () => restrictions?.length && +restrictions[0].other_setup_role_management === 0 ? noWarning() : setModal(<RoleManagmentSetup onSave={closeModal} />),
    },
    {
      description: "Reference Scheme",
      action: () => setModal({
        detached: true,
        Element: <ReferenceSchemeManagePOPUP close={closeModal} />
      }),
    },
  ];

  useEffect(() => {
    const getData = async () => {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const outletStore = db
        .transaction("outlet", "readonly")
        .objectStore("outlet");
      const currentOutlet = (await outletStore.getAll())[0];
      setOutletState({ SMSBalance: currentOutlet?.sms_balance || 0, orderLinks: currentOutlet?.customer_links })
    }
    getData()
  }, [])

  const refreshSMSBalance = async () => {
    if (!navigator?.onLine) return showWarning({ message: 'Internet Connection is required', classname: 'active-red' })
    let res = await fetch(`https://api.myfooddo.com/outlet/${localStorage.getItem('outlet_uuid')}`, {
      method: 'get',
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      }
    })
    if (!res.ok) return;
    res = await res.json()
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = db.transaction("outlet", "readwrite").objectStore("outlet")
    const outlet = await (await tx.getAll())?.[0];
    outlet.sms_balance = res.sms_balance
    tx.put(outlet)
  }

  return (
    <>
      <LeftPanel />
      <div className="right-side">
        <Header />

        <div className={styles.container}>
          <div className={styles.content}>
            <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
              <input
                type="text"
                onChange={(e) => setPattern(e.target.value)}
                value={pattern}
                style={{ "min-width": "250px" }}
                placeholder="Search..."
                className={styles.searchInput}
              />
              <button id={styles.setupMenuWrapper} onMouseOver={e => cursorOverMenu = true} onMouseLeave={e => cursorOverMenu = false} autoFocus={true} onBlur={e => !cursorOverMenu && menuState && setMenuState(false)}>
                <button id={styles.setupMenuToggler} className={menuState ? styles.active : ''} onClick={e => setMenuState(!menuState)}>
                  Options <ArrowDropDown />
                </button>

                {menuState && <div id={styles.setupMenu}>
                  <div onClick={() => Navigate('/Inv-Ac')}>Inventory</div>
                  <div
                    tabIndex={0}
                    className={styles.subMenuToggler}
                    autoFocus={true}
                    onMouseOver={e => mouseOverLinks = true}
                    onMouseLeave={e => mouseOverLinks = false}
                    onBlur={e => !mouseOverLinks && setOrderLinksState(false)}
                  >
                    <div onClick={() => setOrderLinksState(!orderLinksState)}>
                      Ordering Link <ArrowDropDown style={{ transform: orderLinksState ? 'rotate(180deg)' : 'rotate(359deg)' }} />
                    </div>
                    {orderLinksState ? <OrderingLinksWrapper customerLinks={outletState?.orderLinks} /> : ''}
                  </div>
                  <div onClick={() => {
                    setNotification(true)
                    navigator.clipboard.writeText(localStorage.getItem("outlet_uuid"));
                    setTimeout(() => setNotification(false), 3000)
                  }}>Outlet UUID <ContentCopyIcon style={{ marginLeft: '25px', width: '20px', height: '20px' }} /></div>
                  <div onClick={() => setRefreshPage(true)}>Refresh Local Data</div>
                  <div onClick={upload_backup}>Create Local Backup</div>
                  <div onClick={refreshSMSBalance}>SMS Balance: {outletState?.SMSBalance}</div>
                  <div>Version: {VERSION}</div>
                </div>}
              </button>

            </div>
            <SetupTable
              items={tableItems.filter((item) =>
                item.description.toLowerCase().includes(pattern.toLowerCase())
              )}
            />

          </div>

          {modal && (
            !modal.detached
              ? <SetupModal onClose={closeModal}>{modal}</SetupModal>
              : <>{modal.Element}</>
          )}

        </div>
      </div>
      {refreshPage && (<PopupRefresh onSaveClose={() => setRefreshPage(false)} />)}
      <div className={`copies_notification ${notification ? "copies_notification_active" : ""}`}>
        Outlet UUID Copied
      </div>
    </>
  );
}

const OrderingLinksWrapper = ({ customerLinks, close }) => {
  const [copied, setCopied] = useState(false);
  
  return (
    <div id={styles.orderingLinksList}>
      {customerLinks.map((item, index) =>
        <div
          onClick={() => {
            setCopied(index);
            navigator.clipboard.writeText(`https://order.myfooddo.com/${item}`);
            setTimeout(() => setCopied(false), 1000);
          }}>
          https://order.myfooddo.com/
          <b style={{ fontWeight: '600', marginRight: '10px' }}>{item}</b>
          {copied === index
            ? <span style={{ lineHeight: '24px' }}>Copied!!</span>
            : <ContentCopyIcon style={{ marginLeft: '36px' }} />
          }
        </div>
      )}
    </div >
  )
}